// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SelectOutlinedSvg from "@fishx/icons-svg/es/asn/SelectOutlined";
import FishxIcon from '../components/FishxIcon';

var SelectOutlined = function SelectOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SelectOutlinedSvg
  }));
};

SelectOutlined.displayName = 'SelectOutlined';
export default React.forwardRef(SelectOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SelectOutlined.js
// module id = 4079
// module chunks = 0